import Vue from 'vue'
import {
  Select,
  Option,
  OptionGroup,
  Form,
  FormItem,
  Input,
  InputNumber,
  Row,
  Col,
  Button,
  Message,
  Header,
  Container,
  Aside,
  Main,
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Table,
  TableColumn,
  Switch,
  Pagination,
  Dialog,
  MessageBox,
  Tag,
  Loading,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Timeline,
  TimelineItem,
  Notification,
  Alert,
  Drawer,
  Tabs,
  TabPane,
  Upload,
  Image,
  Checkbox,
  CheckboxGroup,
  ColorPicker,
  Radio,
  RadioGroup,
  Carousel,
  CarouselItem,
  Tree,
  DatePicker,
  Tooltip,
  Badge,
  Avatar,
  Empty,
  Cascader,
  Collapse,
  CollapseItem,
  Steps,
  Step,
  RadioButton,
  Descriptions,
  DescriptionsItem,
  Autocomplete,
  Popover
} from 'element-ui'
Dialog.props.lockScroll.default = false
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Header);
Vue.use(Container);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Drawer);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(ColorPicker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Loading);
Vue.use(Tree);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Badge);
Vue.use(Avatar);
Vue.use(Empty);
Vue.use(Cascader);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Steps);
Vue.use(Step);
Vue.use(RadioButton);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Autocomplete);
Vue.use(Popover);

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
Vue.prototype.$alert = Alert
